import { put, call } from "redux-saga/effects";
import { exceptionHandler } from "../pages/common/functions";
import TestimonialService from "../services/api/testimonialService";
import { testimonialConstants } from "../actions/constants/testimonialConstant";

function* testimonialGetByFilter(request: any) {
    try {
        const result = yield call(TestimonialService.testimonialGetByFilter, request.input);
        var res = exceptionHandler(result);
        if (res.status) {
            yield put({
                type: testimonialConstants.Testimonial_GetByFilter_Success,
                payload: res.data
            });
        } else {
            yield put({ type: testimonialConstants.Testimonial_GetByFilter_Failure, payload: res.data });
        }
    } catch (e) {
        yield put({ type: testimonialConstants.Testimonial_GetByFilter_Failure, payload: e });
    }
}

function* testimonialGetDetail(request: any) {
    try {
        const result = yield call(TestimonialService.testimonialGetDetail, request.input);
        var res = exceptionHandler(result);
        if (res.status) {
            yield put({
                type: testimonialConstants.TestimonialDetailSuccess,
                payload: res.data,
            });
        }
        else {
            yield put({ type: testimonialConstants.TestimonialDetailFailure, payload: res.data });
        }
    } catch (error) {
        yield put({ type: testimonialConstants.TestimonialDetailFailure, payload: error });
    }
}

function* testimonialUpdateStatus(request: any) {
    try {
        const result = yield call(TestimonialService.testimonialGetDetail, request.input);
        var res = exceptionHandler(result);
        if (res.status) {
            yield put({
                type: testimonialConstants.TestimonialDetailSuccess,
                payload: res.data,
            });
        }
        else {
            yield put({ type: testimonialConstants.TestimonialDetailFailure, payload: res.data });
        }
    } catch (error) {
        yield put({ type: testimonialConstants.TestimonialDetailFailure, payload: error });
    }
}

function* testimonialStatusUpdate(request: any) {
    try {
        const result = yield call(TestimonialService.testimonialStatusUpdate, request.input);
        const res = exceptionHandler(result)
        if (res.status) {
            yield put({ type: testimonialConstants.TestimonialStatusUpdateSuccess,	payload: res.data });
        }
        else {
            yield put({ type: testimonialConstants.TestimonialStatusUpdateFailure, payload: res.data });
        }
    }
    catch (e) {
        yield put({ type: testimonialConstants.TestimonialStatusUpdateFailure, payload: e });
    }
}

function* testimonialVideoStatusUpdate(request: any) {
    try {
        const result = yield call(TestimonialService.testimonialVideoStatusUpdate, request.input);
        const res = exceptionHandler(result)
        if (res.status) {
            yield put({ type: testimonialConstants.TestimonialVideoStatusUpdateSuccess,	payload: res.data });
        }
        else {
            yield put({ type: testimonialConstants.TestimonialVideoStatusUpdateFailure, payload: res.data });
        }
    }
    catch (e) {
        yield put({ type: testimonialConstants.TestimonialVideoStatusUpdateFailure, payload: e });
    }
}

export const testimonialSaga = {
	testimonialGetByFilter,
    testimonialGetDetail,
    testimonialStatusUpdate,
    testimonialVideoStatusUpdate
}